// resources/assets/js/components/Header.js

import React, { Fragment, useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import AppContext from '../contexts/AppContext'
import { objToEncoded, inSearch, inPath } from '../services/search'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

const NavDropdown = ({ key, location, locations, highlight, active, defaultLabel, locationsLink, linkClassName, liClassName, title }) => {

	const componentId = location ? location.id : defaultLabel ? defaultLabel.replace(' ', '-') : 'no-key'
	const label = defaultLabel ? defaultLabel : location ? location.name : '-'
	const url = location ? location.url : '#'

	return (
		<li className={liClassName ? liClassName : "nav-item dropdown"}>
			<a
				className={(linkClassName ? linkClassName : 'nav-link') + ' dropdown-toggle' + (active ? ' active' : '')}
				id={'statesDropdown-' + componentId} role="button" href={url}
				aria-haspopup="true" aria-expanded="false"
				data-bs-toggle="dropdown"
				title={title ? title : null}
			>
				{label}
			</a>
			<div className="dropdown-menu dropdown-3-column" aria-labelledby={'statesDropdown-' + componentId}>
				{locationsLink &&
					<Link tag="a" to={'/locations'} className='dropdown-item font-weight-bold text-danger'>
						<FontAwesomeIcon icon={faSearch} className="me-2" />Find location
					</Link>
				}
				{locations && locations.length > 0 && locations.map(item =>
					<a
						key={item.id}
						className={
							'dropdown-item'
							+ (item.population > highlight ? ' font-weight-bold' : '')
							+ (location && item.id == location.id ? ' active' : '')
						}
						href={item.url}
						title={process.env.MIX_APP_TITLE}
					>{item.name}</a>
				)}
			</div>
		</li>
	)
}

const Header = ({ fluid, onSearch, history }) => {

	const { data, location, countries, states, cities, setAppState, authServices, messageServices, postServices } = useContext(AppContext)
	const { app } = data
	const user = app?.user
	const user_id = app?.user?.id

	const [ searchResults, setSearchResults ] = useState([])
	const [ searchLoading, setSearchLoading ] = useState(false)
	const [ unreadCount, setUnreadCount ] = useState(0)

	const [ query, setQuery ] = useState('')

	const user_str_id = app && app.user && app.user.str_id ? app.user.str_id : app.user_str_id

	const userListUrl = type => {
		return user_str_id ? ('/search#' + objToEncoded({user_str_id: user_str_id, list: type})) : ''
	}

    const onChange = e => {
        setQuery(e.target.value)
    }

    const userLink = (e, type) => {
		e.preventDefault()
		if(typeof onSearch == 'function' && history.location.pathname == '/search'){
			onSearch({user_str_id: user_str_id, list: type})
		}else{
			history.push(userListUrl(type))
		}
	}

    const [ width, setWidth ] = useState(window.innerWidth)
    const updateDimensions = () => setWidth(window.innerWidth)

    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

	useEffect(() => {
		if(user_id){
			messageServices.unreadCount().then(res => {
				setUnreadCount(res.count)
				setAppState('app.user.unread_count', res.count)
			}).catch(err => {
				console.log(err)
			})
		}
	}, [ user_id ])

	return (
    	<div>
		<nav className="navbar navbar-expand-xl shadow-sm navbar-dark bg-dark">
			<div className={(fluid ? 'container-fluid' : 'container')}>
				<span className="navbar-brand">
					<a href={process.env.MIX_APP_URL} title={process.env.MIX_APP_TITLE}>
						<img src="/images/android-chrome-192x192.png" width="30" height="30" className="rounded d-inline-block align-top me-2" alt={process.env.MIX_APP_NAME} />
					</a>
					<a href={process.env.MIX_APP_URL} className="text-white text-decoration-none" title={process.env.MIX_APP_TITLE}>{process.env.MIX_APP_NAME}</a>
					{location &&
						<Fragment>
							<span> | </span>
							{location.type == 'country' ? (
								<NavDropdown
									location={location}
									locations={countries}
									highlight={65000000}
									active={true}
									liClassName="nav-item dropdown d-inline-block"
									linkClassName="text-white text-decoration-none"
									title={process.env.MIX_APP_TITLE}
								/>
							) : (
								<a href={location.url} className="text-white text-decoration-none" title={process.env.MIX_APP_TITLE}>{location.name}</a>
							)}
						</Fragment>
					}
				</span>
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>

				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav ms-auto">

						{!authServices.isLoggedIn() &&
							<li className="nav-item dropdown">
								<a
									className={"nav-link dropdown-toggle" + (inPath(['/forgot-password', '/login', '/create-account']) ? ' active' : '')}
									href="/login"
									id="accountDropdown"
									role="button"
									data-bs-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									Account
								</a>
								<div className="dropdown-menu" aria-labelledby="accountDropdown">
									<a
										href="/login"
										className={"dropdown-item" + (inPath('/login') ? ' active' : '')}
									>Login</a>
									<a
										href="/create-account"
										className={"dropdown-item" + (inPath('/create-account') ? ' active' : '')}
									>Create account</a>
									<a
										href="/forgot-password"
										className={"dropdown-item" + (inPath('/forgot-password') ? ' active' : '')}
									>Forgot/Reset password</a>
								</div>
							</li>
						}

						{authServices.isLoggedIn() &&
							<li className="nav-item">
								<Link
									tag="a"
									className={"nav-link" + (inPath(['/account/messages']) ? ' active' : '')}
									to="/account/messages"
									id="accountDropdown"
									role="button"
									aria-haspopup="true"
									aria-expanded="false"
								>
									Inbox
									{unreadCount > 0 && <span className="badge bg-danger ms-1">{unreadCount}</span>}
								</Link>
							</li>
						}

						{authServices.isLoggedIn() &&
							<li className="nav-item dropdown">
								<Link
									tag="a"
									className={"nav-link dropdown-toggle" + ((
										inPath(['/account', '/account/posts']) ||
										inSearch({user_str_id: user_str_id, list: 'favorite'}) ||
										inSearch({user_str_id: user_str_id, list: 'hidden'}) ||
										inSearch({user_str_id: user_str_id, list: 'flagged'})
									) ? ' active' : '')}
									to="/account"
									id="accountDropdown"
									role="button"
									data-bs-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									Account {user && <>({user.name})</>}
								</Link>
								<div className="dropdown-menu" aria-labelledby="accountDropdown">
									<Link
										tag="a"
										to="/account"
										className={"dropdown-item" + (inPath('/account') ? ' active' : '')}
									>Dashboard</Link>
									<Link
										tag="a"
										to="/account/posts"
										className={"dropdown-item" + (inPath('/account/posts') ? ' active' : '')}
									>My Posts</Link>
									<a
										href="/account/promos"
										className={"dropdown-item" + (inPath('/account/promos') ? ' active' : '')}
									>My Promotions</a>
									<Link
										tag="a"
										to="/account/credits-and-points"
										className={"dropdown-item" + (inPath('/account/credits-and-points') ? ' active' : '')}
									>Finance</Link>
									<Link
										tag="a"
										to="/account/banner/list"
										className={"dropdown-item" + (inPath('/account/banner/list') ? ' active' : '')}
									>My Banner Ads</Link>
									<div className="dropdown-divider"></div>
									<span className="dropdown-item cursor-pointer" onClick={authServices.appLogout}>Logout</span>
								</div>
							</li>
						}

						<li className="nav-item">
							<a href="/create-post" className="btn btn-success ms-0 ms-xl-2 my-1 my-xl-0 text-nowrap">
								Create Post
							</a>
						</li>
	                    <li className="nav-item">
	                        <Link tag="a" to="/account/banner/create" className="btn btn-success ms-0 ms-xl-2 my-1 my-xl-0 text-nowrap">
	                            Create Banner Ad
	                        </Link>
						</li>
					</ul>

				</div>
			</div>
		</nav></div>
    )
}

export default Header